import Vue from 'vue'
import VueRouter from 'vue-router'
import setDocuemntTtitle from '@/utils/setDocumentTitle'
import store from '@/store'
import { getOpenPageResult, getActivityInfo } from '@/server/interfaces'
import getParamsFromUrl from '@/utils/getParamsFromUrl'
// const home = () => import("../views/Home/index")
const entryPage = () => import('../views/EntryPage/index')
const homePage = () => import('../views/HomePage/index')
const DetailPage = () => import('../views/DetailPage/index')
const nothingnessActivity = () => import('../views/NothingnessActivity/index')
const poster = () => import('../views/Poster/index')
const DreateRoute = () => import('../views/createRoute/index')
const MyRedRoute = () => import('../views/myRedRoute/index')
const LineRouteItem = () => import('../views/LineRouteItem/index')
const ShareRoute = ()=>import('../views/shareRoute/index')
const RecommendRoute = () => import('../views/RecommendRoute/index')
const RecommendRouteDetail = () => import('../views/RecommendRouteDetail/index')

Vue.use(VueRouter)

const routes = [
  {
    path: '/entryPage',
    name: 'entryPage',
    meta: {
      title: '',
      keepAlive: false
    },
    component: entryPage
  },
  {
    path: '/homePage',
    name: 'homePage',
    meta: {
      title: '',
      keepAlive: false
    },
    component: homePage
  },
  {
    path: '/detailPage',
    name: 'DetailPage',
    meta: {
      title: '',
      keepAlive: false
    },
    component: DetailPage
  },
  {
    path: '/nothingnessActivity',
    name: 'nothingnessActivity',
    meta: { title: ' ' },
    component: nothingnessActivity
  },
  {
    path: '/clockIn/:posterType',
    name: 'Poster',
    component: poster,
    props: true,
    meta: {
      title: '',
      keepAlive: false
    }
  },
  {
    path: '/createRoute',
    name: 'DreateRoute',
    meta: {
      title: '定制路线',
      keepAlive: false
    },
    component: DreateRoute
  },
  {
    path: '/myRedRoute',
    name: 'MyRedRoute',
    meta: {
      title: '我的红色路线',
      keepAlive: false
    },
    component: MyRedRoute
  },
  {
    path: '/lineRouteItem',
    name: 'lineRouteItem',
    meta: {
      title: '我的红色路线',
      keepAlive: false
    },
    component: LineRouteItem
  },
  {
    path: '/shareRoute',
    name: 'ShareRoute',
    meta: {
      title: '广东红色地图',
      keepAlive: false
    },
    component: ShareRoute
  },
  {
    path: '/recommendRoute',
    name: 'RecommendRoute',
    meta: {
      title: '推荐路线',
      keepAlive: true
    },
    component: RecommendRoute
  },
  {
    path: '/recommendRouteDetail',
    name: 'RecommendRouteDetail',
    meta: {
      title: '推荐路线',
      keepAlive: false
    },
    component: RecommendRouteDetail
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  console.log(to)
  // 发请求，判断是否有开门页，在决定跳转
  const activityTitle = store.state.activityInfo?.name
  const title = to.meta.title ? to.meta.title : activityTitle || ''
  if (title) {
    setDocuemntTtitle(title)
  }
  if (!to.name) {
    const param = getParamsFromUrl()
    const data = {
      params: {
        id: param.id
      }
    }
    const result = await getOpenPageResult(data)
    const detailRes = await getActivityInfo(data)
    // 提交状态，告知请求已结束
    if (result.id) {
      next(`/entryPage?id=${store.state.activityInfo.activityId}`)
    } else {
      if (detailRes) {
        next(`/homePage?id=${store.state.activityInfo.activityId}`)
      } else {
        next('/nothingnessActivity')
      }
    }
  } else {
    next()
  }
})
export default router
